<template>
  <div>
    <div class="falcon-map-container">
      <div class="falcon-map" :class="locked? 'locked': ''" ref="chart" id="falcon-map">
        <div class="north-america">1092</div>
        <div class="south-america">175</div>
        <div class="africa">58</div>
        <div class="europe">1136</div>
        <div class="australia">79</div>
        <div class="asia">405</div>
      </div>

    </div>
    <div class="sep-12"></div>
    <div class="map-table align-x-center" :class="locked? 'locked': ''">
      <table>
        <tr>
          <th>Region</th>
          <th>Count</th>
          <th>AVG Pre-Money Valuation</th>
        </tr>
        <tr :class="['France', 'Europe', 'United Kingdom', 'Italy'].indexOf(this.group)>-1? 'selected': ''">
          <td>Europe</td>
          <td>1136</td>
          <td>{{ '4052597'|formatDollarsNoZeros }}</td>
        </tr>
        <tr :class="['United States', 'Canada'].indexOf(this.group)>-1? 'selected': ''">
          <td>North America</td>
          <td>1092</td>
          <td>{{ '4544414'|formatDollarsNoZeros }}</td>
        </tr>
        <tr :class="['Latin America'].indexOf(this.group)>-1? 'selected': ''">
          <td>South America</td>
          <td>175</td>
          <td>{{ '2098571'|formatDollarsNoZeros }}</td>
        </tr>
        <tr :class="['Asia', 'Asia & Pacific', 'Gulf Countries', 'East Asia', 'Middle East'].indexOf(this.group)>-1? 'selected': ''">
          <td>Asia</td>
          <td>405</td>
          <td>{{ '3008642'|formatDollarsNoZeros }}</td>
        </tr>
        <tr :class="['Australia'].indexOf(this.group)>-1? 'selected': ''">
          <td>Australia</td>
          <td>79</td>
          <td>{{ '4104430'|formatDollarsNoZeros }}</td>
        </tr>
        <tr :class="['Africa'].indexOf(this.group)>-1? 'selected': ''">
          <td>Africa</td>
          <td>58</td>
          <td>{{ '2797414'|formatDollarsNoZeros }}</td>
        </tr>
      </table>
    </div>
  </div>
</template>

<script>
import Chart from 'chart.js';
import {CHART_COLORS} from "./chartColors";
import echarts from "echarts";

export default {
  name: 'worldRangeGraph',
  data() {
    return {
      graphData: this.data,
    }
  },
  props: ['data', 'locked', 'print', 'group'],
  mounted() {


    // google.charts.load('current', {
    //   'packages': ['geochart'],
    //   // Note: you will need to get a mapsApiKey for your project.
    //   // See: https://developers.google.com/chart/interactive/docs/basic_load_libs#load-settings
    //   'mapsApiKey': 'AIzaSyD-9tSrke72PouQMnMX-a7eZSW0jkFMBWY',
    //
    // });
    // google.charts.setOnLoadCallback(drawRegionsMap);
    // let isPrint = this.print;
    //
    // function drawRegionsMap() {
    //   var data = new google.visualization.DataTable();
    //   data.addColumn('string', 'Region');
    //   data.addColumn('number', 'Count');
    //   data.addColumn('number', 'AVG Pre-Money Valuation');
    //   data.addRows([
    //     [{v: "154", f: "Europe"}, 1136, 4052597], // 0
    //     [{v: "155", f: "Europe"}, 1136, 4052597],
    //     [{v: "151", f: "Europe"}, 1136, 4052597],
    //     [{v: "039", f: "Europe"}, 1136, 4052597],
    //
    //     [{v: "021", f: "North America"}, 1092, 4544414], // 4
    //     [{v: "029", f: "North America"}, 1092, 4544414],
    //     [{v: "013", f: "North America"}, 1092, 4544414],
    //     //
    //     [{v: "005", f: "South America"}, 175, 2098571],// 7
    //     //
    //     [{v: "143", f: "Asia"}, 405, 3008642], // 8
    //     [{v: "030", f: "Asia"}, 405, 3008642],
    //     [{v: "034", f: "Asia"}, 405, 3008642],
    //     [{v: "035", f: "Asia"}, 405, 3008642],
    //     [{v: "145", f: "Asia"}, 405, 3008642],
    //     //
    //     [{v: "053", f: "Australia"}, 79, 4104430], //13
    //     [{v: "054", f: "Australia"}, 79, 4104430],
    //     [{v: "057", f: "Australia"}, 79, 4104430],
    //     [{v: "061", f: "Australia"}, 79, 4104430],
    //     //
    //     [{v: "015", f: "Africa"}, 58, 2797414],
    //     [{v: "011", f: "Africa"}, 58, 2797414],
    //     [{v: "017", f: "Africa"}, 58, 2797414],
    //     [{v: "014", f: "Africa"}, 58, 2797414],
    //     [{v: "018", f: "Africa"}, 58, 2797414]
    //   ]);
    //
    //   var options = {
    //     colorAxis: {colors: ['#fff', '#d4e2e4']},
    //     resolution: 'subcontinents',
    //     enableInteractivity: false,
    //     focusTarget: 'category',
    //     backgroundColor: {},
    //     defaultColor: '#fff',
    //     legend: 'none',
    //   };
    //
    //   var chart = new google.visualization.GeoChart(document.getElementById('falcon-map'));
    //
    //   chart.draw(data, options);
    // };
  },
  methods: {},
  computed: {},
}
</script>

<style scoped lang="scss">
.falcon-map {
  /*background-size: contain;*/
  width: 715px;
  margin: auto;
  height: 350px;
  background-image: url(../../../images/wordmap.svg);
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center;
  position: relative;

  div {
    position: absolute;
    top: 0;
    left: 0;
    background-color: #222f3c;
    border-radius: 50%;
    width: 54px;
    height: 54px;
    line-height: 54px;
    text-align: center;
    font-size: 18px;
    color: #fff;
  }

  .north-america {
    top: 94px;
    left: 62px;
  }

  .south-america {
    top: 240px;
    left: 154px;
  }

  .africa {
    top: 200px;
    left: 314px;
  }

  .europe {
    top: 29px;
    left: 309px;
  }

  .australia {
    top: 230px;
    left: 522px;
  }

  .asia {
    top: 0;
    left: 500px;
  }
}

.falcon-map-container {
  position: relative;
  width: 100%;
  height: 350px;

}


.map-table {
  width: 500px;

  table {
    width: 100%;
  }

  padding: 8px;
  background-color: #D2F2F2;
  border-radius: 4px;

  tr td {
    padding: 5px;
    min-width: 100px;
    border-bottom: 1px solid #A7ACB2;
  }

  tr:last-child td {
    border-bottom: none;
  }
}

.falcon-map-container {
  position: relative;
}

.selected {
  td {
    font-weight: bold;
    color: #1EBCBE;
  }
}
</style>
